// @flow
import React from 'react';
import { useSelector } from 'react-redux';
import { hasPermission } from 'utils/user-utils';
import { UCD_RESOURCE_FIELDS } from 'omega-rtc/constants/ucd';

type AuthCondition = {
  resource: string,
  action: string,
};

type Props = {
  conditions: Array<AuthCondition>,
  unauthorizedContent: React.Element,
};

const ShowIfAuthorized: React.FC<Props> = ({ conditions, unauthorizedContent, children }) => {
  const userPermissions = useSelector((state: StoreState) => state.app.user.userPermissions);

  if (!userPermissions) {
    return '';
  }

  const isAuthorized =
    conditions.some(condition =>
      hasPermission(userPermissions, condition.resource, UCD_RESOURCE_FIELDS.all, condition.action)
    );

  return (
    <React.Fragment>
      {isAuthorized ? children : unauthorizedContent}
    </React.Fragment>
  );
};

export default ShowIfAuthorized;
